import { useCallback, useState } from 'react';
import { Button } from '@shared/components/Button';
import { i18n } from '@shared/util/i18n';

export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [text]);

  return (
    <Button
      variant="tertiary"
      size="small"
      icon="squares-stacked"
      iconOnly
      onClick={handleCopy}
      tooltip={copied ? i18n('common.copied') : i18n('common.copy')}
      tooltipPosition="top"
    />
  );
}
